<template>
  <div :class="classes">
    <a
      v-for="(option, index) in options"
      :key="index"
      :class="optionClasses(option, index)"
      v-bind="optionHref(option, index)"
    >
      <span v-if="optionDone(option, index)" class="checkout-bar__item__number"><m4-icon icon="check"></m4-icon></span>
      <span v-else class="checkout-bar__item__number">{{ (index+1) }}</span>
      <span class="checkout-bar__item__text">{{ option.title }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "M4CheckoutBar",
  props: {
    options: Array,
    selected: String
  },
  computed: {
    classes() {
      let classes = ["checkout-bar"];
      return classes;
    },
    selectedIndex() {
      if (this.selected) {
        return this.options.findIndex((option) => {
          if (option.key === this.selected) {
            return option;
          }
        });
      }
      return null;
    }
  },
  methods: {
    optionClasses(option, index) {
      let classes = ["checkout-bar__item"];
      if (this.selectedIndex > index) {
        classes.push("checkout-bar__item--active");
      }
      if (this.selectedIndex === index) {
        classes.push("checkout-bar__item--current");
      } else if (this.options.length - 1 === this.selectedIndex) {
        classes.push("checkout-bar__item--done");
      }
      return classes;
    },
    optionHref(option, index) {
      if (this.options.length - 1 === this.selectedIndex) {
        return {};
      }
      if (this.selectedIndex > index) {
        return { href: option.link };
      }
      return {};
    },
    optionDone(option, index) {
      return this.selectedIndex > index;
    }
  }
};
</script>
